import { ChatMessage } from '@ant-design/pro-chat';
import { ExportOutlined } from '@ant-design/icons';
import CustomChatItem from '../ChatItem';
import { ContentObject, SetupConfig } from '../../../interfaces/copilotChat';
import { hasArtifactName, getArtifactName } from '../../../utils/artifactUtils';
import classNames from 'classnames';

interface SetUpConfigMessageProps {
  className?: string;
  message: ChatMessage;
  result: Omit<ContentObject, 'setupConfig'> & { setupConfig: SetupConfig };
}

const SetUpConfigMessage: React.FC<SetUpConfigMessageProps> = ({
  className,
  message,
  result,
}) => {
  const sObjectLabel =
    result.setupConfig.sObjectLabel || result.setupConfig.sObjectName || '';
  const artifactName = hasArtifactName(result.setupConfig)
    ? getArtifactName(result.setupConfig)
    : '';
  const separator = sObjectLabel && artifactName ? ' - ' : '';
  return (
    <div
      className={classNames(
        className,
        'artifact-message-content',
        'setup-config',
        message.role
      )}
    >
      {result.text && <CustomChatItem message={result.text} />}
      <p>
        <a
          href={result.setupConfig?.url}
          target="_blank"
          rel="noopener noreferrer"
          title="Click here to open the page in new tab"
          className="artifact-message-link"
        >
          <span>
            Link to {result.setupConfig.type}: {sObjectLabel}
            {separator}
            {artifactName}
          </span>
          <span>
            <ExportOutlined />
          </span>
        </a>
      </p>
    </div>
  );
};

export default SetUpConfigMessage;
